<div (click)="openSegmentFilters()">
  <img src="assets/imgs/icons/pin-location.svg" />
</div>
